import { Subdimension } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';

export const subdimensionId = (options: Pick<Subdimension, 'name' | 'value'>) =>
  [options.name, options.value].join('-');
